import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
        data: {
            title: 'itechnov.home.title'
        }
    },
    {
        path: 'about-us',
        loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule),
        data: {
            title: 'itechnov.aboutus.title'
        }
    },
    {
        path: 'contact-us',
        loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule),
        data: {
            title: 'itechnov.contactus.title'
        }
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    }/* ,
    {
        path: '**',
        redirectTo: '/home',
    } */
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledBlocking'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
